import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';
import { PermissionGroupDetails } from '../../../../../../../api/types/settings/permissions/permission-group-details.type';

export const getPermissionGroupDetailsOperation = async (
  groupId: number,
  setData: (data: PermissionGroupDetails | null) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getPermissionGroupById(groupId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setData(null);
      return;
    }

    setData(res.data.body ?? null);
  } catch (e) {
    console.error('getPermissionGroupDetailsOperation failed:', e);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setData(null);
  } finally {
    setLoading(false);
  }
};
